export const QA_NAME_CALENDAR_RAIL_DONE_TASKS = 'calendarRailDoneTasks'

export const QA_NAME_CALENDAR_RAIL_CANCELLED_APPOINTMENTS =
  'calendarRailCancelledAppointments'
